import { onConsentChange } from './onConsentChange.js';
const onConsent = () => new Promise((resolve, reject) => {
    onConsentChange((consentState) => {
        if (consentState.tcfv2 ?? consentState.usnat ?? consentState.aus) {
            resolve(consentState);
        }
        reject("Unknown framework");
    });
});
export { onConsent };
